export const HEADERS_MULTISTEP = {
  stakeholder: [
    { name: 'Stakeholder' },
    { name: 'Information' },
    { name: 'People' },
    { name: 'Communicators' },
  ],
  changeStrategy: [
    { name: 'General' },
    { name: 'Details' },
    { name: 'Governance' },
    { name: 'Milestones' },
    { name: 'Linked files' },
  ],
  portfolio: [
    { name: 'General' },
    { name: 'Details' },
    { name: 'Milestones' },
    { name: 'Linked Files' },
  ],
};
